import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { Images } from "@assets/images";
import { ChangeEvent, useCallback, useState } from "react";
import UploadMediaService from "@app/services/http/upload-media.service";
import { useFormikContext } from "formik";
import { UserTypeOptions } from "@app/constants";
import BookService from "@app/services/http/book.service";
import { LabelValue } from "@app/types";
import Checkbox from "@app/components/checkbox";
import CustomAsyncMultiSelect from "@app/components/custom-async-multi-select";

const BannerComponent = () => {
  const [bannerMediaFile, setBannerMediaFile] = useState<File | null>(null);
  const formik = useFormikContext<any>();
  const [isTypeUser, setIsTypeUser] = useState(false);


  const handleTypeUserChange = (e: ChangeEvent<HTMLInputElement>) => {
    setIsTypeUser(e.target.checked);
  };

  const fetchUserOptions = async (inputValue: string) => {
    return UserTypeOptions.filter((option) => option.value !== "ALL").filter(
      (option) => option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const fetchBookOptions = useCallback(async (inputValue: string) => {
    const res = await BookService.getRetailBooks(
      { keyword: inputValue, pageNum: 1, pageSize: 20 },
      undefined,
      false
    );

    return (res.data?.items || []).map((it: LabelValue) => ({
      label: it.label,
      value: it.value,
    }));
  }, []);

  return (
    <div className="w-[100%]">
      <div className="text-[#343C6A] font-medium mb-2">
        Danh sách popup banner{" "}
      </div>
      <div className="bg-white py-6 px-5 rounded-xl">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Nội dung banner
            </label>
            <FormControl name="content">
              <Input placeholder="Nhập nội dung banner" />
            </FormControl>
          </div>
          <div className="w-100">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Các user id test
            </label>
            <FormControl name="bannerTestingIds">
              <Input placeholder="Nhập ID, cách nhau dấu phẩy" />
            </FormControl>
            <div className="text-xs text-[#83898C] mt-1">
              Nhập các userId cách nhau bởi dấu &quot;,&quot;. Ex: 1,2,3
            </div>
          </div>
          <div className="w-100 col-span-2">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Hình ảnh banner
            </label>

            {/* Image Preview */}
            {(formik.values.bannerMedia || bannerMediaFile) && (
              <div className="mb-4">
                <img
                  src={
                    bannerMediaFile
                      ? URL.createObjectURL(bannerMediaFile)
                      : formik.values.bannerMedia
                  }
                  alt="Preview"
                  className="w-32 h-32 object-cover rounded-lg border border-gray-200"
                />
              </div>
            )}

            <label className="bg-[rgba(239,241,249,0.6)] rounded-lg px-4 py-2 h-[52px] cursor-pointer flex items-center justify-between">
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={async (e) => {
                  const file = e.target.files && e.target.files[0];

                  setBannerMediaFile(file ?? null);

                  if (file) {
                    try {
                      const res = await UploadMediaService.upload({
                        medias: [file],
                      });
                      const url = res.data?.items?.[0]?.url || "";

                      if (url) {
                        formik.setFieldValue("bannerMedia", url);
                      }
                    } catch (error) {
                      // ignore
                    }
                  }
                }}
              />
              <div className="text-[#ABAFB1] text-base truncate mr-3">
                {bannerMediaFile?.name || "Upload"}
              </div>
              <img
                src={Images.UploadIcon.default}
                alt="upload"
                className="w-6 h-6"
              />
            </label>
          </div>
          <div className="w-100">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Thời gian kích hoạt
            </label>
            <FormControl name="startDate">
              <Input type="date" placeholder="Chọn ngày bắt đầu" />
            </FormControl>
          </div>
          <div className="w-100">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Thời gian kết thúc
            </label>
            <FormControl name="endDate">
              <Input type="date" placeholder="Chọn ngày kết thúc" />
            </FormControl>
          </div>
          <p className="text-sm text-[#FC4040] col-span-2">
            Ghi chú: Nếu không có thì sẽ áp dụng từ lúc tạo cho tới khi hiển thị
            hết số lần campaing
          </p>
          <div className="w-100">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Tiêu đề button
            </label>
            <FormControl name="titleButton">
              <Input type="text" placeholder="Nhập tiêu đề button" />
            </FormControl>
          </div>
          <div className="w-100">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Hành động button
            </label>
            <FormControl name="actionButton">
              <Input type="text" placeholder="Nhập hành động button" />
            </FormControl>
          </div>
          <div className="w-100">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Số lần hiển thị khi mở app
            </label>
            <FormControl name="totalDisplayCount">
              <Input type="number" placeholder="Nhập số lần hiển thị" />
            </FormControl>
          </div>
          <div className="w-100">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Thời gian hiển thị (giây)
            </label>
            <FormControl name="totalDisplayTime">
              <Input type="number" placeholder="Nhập thời gian hiển thị" />
            </FormControl>
          </div>
          <div>
            <div className="mt-3 flex items-center gap-4">
              <Checkbox
                label="Loại user"
                labelClassName="text-sm text-[#83898C]"
                onChange={handleTypeUserChange}
                checked={isTypeUser}
              />
            </div>
            {isTypeUser && (
              <>
                <div className="w-[50%] mt-4">
                  <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                    Loại user
                  </label>
                  <FormControl name="bannerUserType">
                    <CustomAsyncMultiSelect
                      promiseOptions={fetchUserOptions}
                      className="rounded-lg"
                      placeholder="Chọn loại user"
                    />
                  </FormControl>
                </div>
                <div className="w-[50%] mt-4">
                  <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                    User đã nghe trên số phút
                  </label>
                  <FormControl name="bannerUserListenedToMinutes">
                    <Input type="number" placeholder="Nhập số phút" />
                  </FormControl>
                </div>
                <div className="w-[50%] mt-4">
                  <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                    Tài khoản kas của user đang lớn hơn
                  </label>
                  <FormControl name="bannerKasIsGreaterThan">
                    <Input type="number" placeholder="Nhập số kas" />
                  </FormControl>
                </div>
                <div className="w-[50%] mt-4">
                  <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                    Tài khoản kas của user đang nhỏ hơn
                  </label>
                  <FormControl name="bannerKasIsLessThan">
                    <Input type="number" placeholder="Nhập số kas" />
                  </FormControl>
                </div>
                <div className="w-[100%] mt-4">
                  <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                    User đang có sách lẻ
                  </label>
                  <FormControl name="bannerHasPurchasedBooks">
                    <CustomAsyncMultiSelect
                      placeholder="Chọn sách user đã mua"
                      promiseOptions={fetchBookOptions as any}
                    />
                  </FormControl>
                </div>
                <div className="w-[100%] mt-4">
                  <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                    User chưa có sách lẻ
                  </label>
                  <FormControl name="bannerNotHasPurchasedBooks">
                    <CustomAsyncMultiSelect
                      placeholder="Chọn sách user chưa mua"
                      promiseOptions={fetchBookOptions as any}
                    />
                  </FormControl>
                </div>
              </>
            )}
            <div className="mt-3 flex items-center gap-4">
              <label htmlFor="">
                <FormControl name="bannerBirthday">
                  <Checkbox
                    label="Sinh nhật trong khoảng thời gian campaign"
                    labelClassName="text-sm text-[#83898C]"
                  />
                </FormControl>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerComponent;
